module.exports = __webpack_public_path__ + "4cf506a92b2bd4b958a25a06fecdbf95.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_2-mobile.png
// module id = 122
// module chunks = 1